import React from "react";
import { Link } from "react-router-dom";
import { FiUser, FiCalendar, FiArrowUpRight } from "react-icons/fi";
import { BLOG_POSTS } from "../data/blogData";

function BlogSection() {
  // Show latest 3 posts
  const posts = BLOG_POSTS.slice(0, 3);

  return (
    <section id="blogs" className="blog-section">
      <div className="blog-header">
        <p>— Our Blog —</p>
        <h2>
          Insights &amp; Innovations:
          <br />
          Our Latest Blog Posts
        </h2>
        <span>
          Explore our blog to discover actionable insights, success stories, and
          expert advice that can help drive growth for your business.
        </span>
      </div>

      <div className="blog-grid">
        {posts.map((post) => (
          <article className="blog-card" key={post.id}>
            <Link to={`/blog/${post.id}`}>
              <img src={post.image} alt={post.title} />
            </Link>
            <div className="blog-content">
              <div className="blog-meta">
                <span><FiUser /> {post.author}</span>
                <span><FiCalendar /> {post.date}</span>
              </div>
              <h3>
                <Link to={`/blog/${post.id}`}>{post.title}</Link>
              </h3>
              <p>{post.excerpt}</p>
              <Link to={`/blog/${post.id}`} className="blog-read-more-link">
                Read More <FiArrowUpRight />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default BlogSection;
